import wordCaps from 'src/utils/wordCaps'

export const shoppingListProductTypeLabel = product => {
  const raw = product?.type || product?.product?.type || ''
  return wordCaps(String(raw).trim()).trim()
}

export const shoppingListSearchSku = product =>
  String(product?.sku || product?.product?.sku || '').trim()

const matchesTerm = (product, term) => {
  const query = String(term || '')
    .trim()
    .toLowerCase()
  if (!query) return true
  const title = String(product?.title || '').toLowerCase()
  const sku = shoppingListSearchSku(product).toLowerCase()
  return title.includes(query) || sku.includes(query)
}

/** Catalogue-style scope: text on title/SKU, then supplier and type. */
export const filterShoppingListProducts = (
  products = [],
  { searchTerm = '', supplierTitle = '', productType = '' } = {},
) =>
  (Array.isArray(products) ? products : []).filter(product => {
    if (!matchesTerm(product, searchTerm)) return false
    if (supplierTitle && product?.supplierTitle !== supplierTitle) return false
    if (productType && shoppingListProductTypeLabel(product) !== productType) {
      return false
    }
    return true
  })
